var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { QuestionCorrectWrong } from '../../../../../questiontype/CorrectWrong/QuestionCorrectWrong';
import { AbfragerMultipleChoiceOptionsLayoutButton } from './AbfragerMultipleChoiceOptionsLayoutButton';
import { AbfragerMultipleChoiceOptionsLayoutGrid } from './AbfragerMultipleChoiceOptionsLayoutGrid';
import { AbfragerMultipleChoiceOptionsLayoutRow } from './AbfragerMultipleChoiceOptionsLayoutRow';
import { QuestionAssociate } from '../../../../../questiontype/Associate/QuestionAssociate';
let AbfragerMultipleChoiceOptionsLayout = class AbfragerMultipleChoiceOptionsLayout extends React.PureComponent {
    render() {
        const { question, children } = this.props;
        let OptionsLayout = AbfragerMultipleChoiceOptionsLayoutRow;
        if (question instanceof QuestionAssociate || question.layoutName.includes('Grid')) {
            OptionsLayout = AbfragerMultipleChoiceOptionsLayoutGrid;
        }
        if (question instanceof QuestionCorrectWrong) {
            OptionsLayout = AbfragerMultipleChoiceOptionsLayoutButton;
        }
        return React.createElement(OptionsLayout, { question: question }, children);
    }
};
AbfragerMultipleChoiceOptionsLayout = __decorate([
    observer
], AbfragerMultipleChoiceOptionsLayout);
export { AbfragerMultipleChoiceOptionsLayout };
